<!--
  File name: PBNEFDefaults.vue
  Program Description:
    - This component contains the default values from PDBNF that needs to be
      shown in the PBNEF form
-->
<template>
  <span>
    <v-row>
      <v-col>
        <v-text-field
          v-model="docketNumber"
          label="Docker Number"
          disabled
          :outlined="!$meta.readOnly"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="nameOfPic"
          label="PIC"
          disabled
          :outlined="!$meta.readOnly"
        />
      </v-col>
      <v-col
        v-if="forAdjudication"
      >
        <v-autocomplete
          id="endorsedTo"
          v-model="endorsedTo"
          append-icon=""
          :items="users.filter(x => x.userRole.includes('adjudicationRecipient'))"
          item-value="_id"
          item-text="fullName"
          label="Endorsed To"
          disabled
          :outlined="!$meta.readOnly"
        />
      </v-col>
      <v-col v-if="approveReject && approveReject !== ''">
        <p class="gray---text pa-0 ma-0 label">
          PBNEF Status
        </p>
        <div :class="`status ${isApproved ? 'approve': 'reject'}`">
          {{ approveReject }}
        </div>
      </v-col>
    </v-row>
  </span>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'ViewForm',
  computed: {
    ...mapFields('pbnef', {
      docketNumber: 'docketNumber',
      $meta: '$meta',
      approveReject: 'approveReject',
      nameOfPic: 'nameOfPic',
      endorsedTo: 'endorsedTo',
      users: 'users',
      forAdjudication: 'forAdjudication'
    }),
    isApproved () {
      return this.approveReject === 'Approved'
    }
  }
}
</script>

<style scoped>
.status {
  display: inline-block;
  padding: 2px 14px;
  margin: 0px;
  font-size: 13px;
  border-radius: 15px;
  background-color: white;
  height: 30px
}
.approve {
  color:#218100;
  border: 1px solid #218100;
}
.reject {
  color:#A22929;
  border: 2px solid #A22929;
}
.label {
  font-size: 11px;
  margin-top: 5px;
  color: #ADACAC;
}
</style>
